import * as React from 'react';
import { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
} from '@mui/material';
import MAutoComplete from '../../../components/controls/MAutoComplete';
import { Close, Save } from '@mui/icons-material';

interface IData {
    [key: string]: any;
}

const SelectTagsDialog: React.FC<IData> = ({ tags, open, mode, onClose, onSave }) => {
    // State to keep track of tags selected *within the dialog*
    const [selectedTags, setSelectedTags] = useState<any[]>([]);

    React.useEffect(() => {
        // only run if open page
        if (open) {
            if (mode === 'remove') {
                let rmtags = [...document.querySelectorAll('[name="sm_tags_contains"] .MuiChip-label')].map((x: any) => x.innerText);
                setSelectedTags(rmtags);
            }
        }
    }, [open, mode]);
    // Return if not open
    if (!open) return null;

    const handleSelection = (props) => {
        setSelectedTags(props);
    };

    const handleSave = () => {
        onSave(selectedTags);
        setSelectedTags([]); // Reset for next time
    };

    const handleClose = () => {
        onClose();
        setSelectedTags([]); // Reset for next time
    };

    const title = mode === 'add' ? 'Add Tags to Selected Events' : 'Remove Tags from Selected Events';

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                {tags && (
                    <Box display="flex" flexWrap="wrap" gap={1} mt={1}>
                        <MAutoComplete choices={tags} label={'Tags'} onChange={handleSelection}
                            defaultValue={selectedTags}
                        />
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} startIcon={<Close />} >Cancel</Button>
                <Button onClick={handleSave} disabled={selectedTags.length === 0} startIcon={<Save/>} color={mode === 'add' ? 'success' : 'error'}>
                    {mode === 'add' ? 'Add Tags' : 'Remove Tags'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SelectTagsDialog;